import React from "react";
import columns from "../../../../../react-table/helpers/columns";
import ReportDefinitions from "../../../../../common/config/ReportDefinitions";
import ExternalLink from "../../../../common/components/ExternalLink";
import config from "../../../../../../core/config/configureSettings";

export const getDetailsTabNavOptions = (rowInfo) =>
  rowInfo && rowInfo.row
    ? {
        reportId: ReportDefinitions.ITEM_OVERVIEW_DETAILS_200.id,
        mainReportId: ReportDefinitions.ITEM_OVERVIEW_V1_200.id,
        requestParams: {
          itemId: rowInfo.row["impc.itemId"],
        },
        selectionCriteriaOptions: {
          includeSelectionCriteria: true,
        },
      }
    : {};

export default (data) => {
  const { TextColumn, NumberColumn, DateTimeColumn, NavigationColumn } =
    columns(data);

  class ExternalEntryDateLinkColumn {
    constructor(column) {
      Object.assign(this, column);
      this.Cell = (row) => {
        const entryDateValue = row.value;
        const itemId = row.original["impc"]?.itemId;

        const dateTimeColumn = new DateTimeColumn("temp", "temp");
        const formattedDate = dateTimeColumn.Cell
          ? dateTimeColumn.Cell(row)
          : entryDateValue;

        const path = `/en/item/${itemId}`;
        const { atatSystem } = config.applications;

        return React.createElement(ExternalLink, {
          host: atatSystem,
          label: formattedDate,
          path,
        });
      };
    }
  }

  return [
    {
      Header: "Operator",
      columns: [
        new TextColumn("From", "operator.from"),
        new TextColumn("To", "operator.to"),
      ],
    },
    {
      Header: "Country",
      columns: [
        new TextColumn("From", "country.from"),
        new TextColumn("To", "country.to"),
      ],
    },
    {
      Header: "IMPC",
      columns: [
        new TextColumn("From", "impc.from"),
        new TextColumn("To", "impc.to"),
      ],
    },
    {
      Header: "",
      columns: [
        new ExternalEntryDateLinkColumn(
          new DateTimeColumn("Entrydate", "impc.entryDate")
        ),
        new NavigationColumn(
          new TextColumn("Item ID", "impc.itemId"),
          getDetailsTabNavOptions
        ),
        new TextColumn("Outw OE", "impc.outwardOE"),
        new TextColumn("Inw OE", "impc.inwardOE"),
        new TextColumn("Delivery office", "impc.deliveryOffice"),
        new DateTimeColumn("EMA", "impc.ema"),
        new TextColumn("ITMATT", "inItmatt"),
        new DateTimeColumn("EMB", "impc.emb"),
        new DateTimeColumn("EXA", "impc.exa"),
        new DateTimeColumn("EXB", "impc.exb"),
        new DateTimeColumn("EXC", "impc.exc"),
        new DateTimeColumn("EXD", "impc.exd"),
        new DateTimeColumn("EXX", "impc.exx"),
        new DateTimeColumn("EMC", "impc.emc"),
        new DateTimeColumn("EMJ", "impc.emj"),
        new DateTimeColumn("EMK", "impc.emk"),
        new DateTimeColumn("Despatch closed", "impc.despatchClosedDate"),
        new DateTimeColumn("PRECON", "impc.precon"),
        new DateTimeColumn("CARDIT 47", "impc.cardit47"),
        new DateTimeColumn("RESDIT 74", "impc.resdit74"),
        new DateTimeColumn("RESDIT 21", "impc.resdit21"),
        new DateTimeColumn("RESDIT 23", "impc.resdit23"),
        new DateTimeColumn("POD", "impc.pod"),
        new DateTimeColumn("RESCON", "impc.rescon"),
        new DateTimeColumn("Bag scan", "impc.bagScan"),
        new DateTimeColumn("EMD", "impc.emd"),
        new DateTimeColumn("EDA", "impc.eda"),
        new DateTimeColumn("EDB", "impc.edb"),
        new DateTimeColumn("EME", "impc.eme"),
        new DateTimeColumn("EDC", "impc.edc"),
        new DateTimeColumn("EMF", "impc.emf"),
        new DateTimeColumn("EDD", "impc.edd"),
        new DateTimeColumn("EDE", "impc.ede"),
        new DateTimeColumn("EMG", "impc.emg"),
        new DateTimeColumn("EDF", "impc.edf"),
        new DateTimeColumn("EDG", "impc.edg"),
        new DateTimeColumn("EDH", "impc.edh"),
        new DateTimeColumn("EDX", "impc.edx"),
        new DateTimeColumn("EMH", "impc.emh"),
        new DateTimeColumn("EMI", "impc.emi"),
        new TextColumn("Dutiable", "impc.dutiable"),
        new NumberColumn("E2E ops", "impc.e2eOps"),
        new NumberColumn("E2E business", "impc.e2eBusiness"),
        new NumberColumn("Days in customs", "impc.daysInCustoms"),
      ],
    },
    {
      Header: "Duration",
      columns: [
        new NumberColumn("Leg 1", "duration.leg1"),
        new NumberColumn("Leg 2", "duration.leg2"),
        new NumberColumn("Leg 3", "duration.leg3"),
        new DateTimeColumn("EDH on network", "duration.edhOnNetwork"),
        new DateTimeColumn("EMH on network", "duration.emhOnNetwork"),
        new DateTimeColumn("EMI on network", "duration.emiOnNetwork"),
        new TextColumn("Despatch ID", "duration.despatchId"),
        new TextColumn("Receptacle ID", "duration.receptacleId"),
        new TextColumn("Addressee postcode", "duration.addresseePostCode"),
        new TextColumn("Place of destination", "duration.placeOfDestination"),
      ],
    },
    {
      Header: "EMA",
      columns: [
        new TextColumn("Origin office", "ema.originOffice"),
        new TextColumn("Sender postcode", "ema.senderPostCode"),
        new TextColumn("Origin location", "ema.originLocation"),
        new NumberColumn("Entryweek", "ema.entryWeek"),
        new NumberColumn("Entrymonth", "ema.entryMonth"),
        new NumberColumn("EMA Gross Weight", "impc.emaWeight"),
        new NumberColumn("EMC Gross Weight", "impc.emcWeight"),
      ],
    },
  ];
};
